import { useUtm } from '@gojiraf/useutm'
import qs from 'qs'
import UtmUtils from '../utils/utmUtils'
export function useCanJoinEvent() {
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  const { utm_medium } = UtmUtils.getUtmObject(queryParams)
  const { isAllowedToJoinCall } = useUtm(utm_medium)

  return {
    canBypassJoin: isAllowedToJoinCall,
  }
}
